<div class="signup-page">
  <!-- Lado Esquerdo - Hero Section com Beneficios -->
  <div class="signup-hero">
    <div class="hero-content">
      <!-- Logo -->
      <div class="hero-logo">
        <img src="assets/images/logo_avatipro.png" alt="Avati Pro" />
      </div>

      <!-- Titulo Principal -->
      <h1 class="hero-title">{{ 'signup.hero.titulo' | translate }}</h1>
      <p class="hero-subtitle">{{ 'signup.hero.subtitulo' | translate }}</p>

      <!-- Lista de Beneficios -->
      <div class="benefits-list">
        <div class="benefit-item">
          <div class="benefit-icon">
            <i class="pi pi-chart-line"></i>
          </div>
          <div class="benefit-text">
            <h3>{{ 'signup.benefits.gestao_completa.titulo' | translate }}</h3>
            <p>{{ 'signup.benefits.gestao_completa.descricao' | translate }}</p>
          </div>
        </div>

        <div class="benefit-item">
          <div class="benefit-icon">
            <i class="pi pi-mobile"></i>
          </div>
          <div class="benefit-text">
            <h3>{{ 'signup.benefits.acesso_facil.titulo' | translate }}</h3>
            <p>{{ 'signup.benefits.acesso_facil.descricao' | translate }}</p>
          </div>
        </div>

        <div class="benefit-item">
          <div class="benefit-icon">
            <i class="pi pi-shield"></i>
          </div>
          <div class="benefit-text">
            <h3>{{ 'signup.benefits.seguranca.titulo' | translate }}</h3>
            <p>{{ 'signup.benefits.seguranca.descricao' | translate }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Circulos Decorativos -->
    <div class="decorative-circle circle-1"></div>
    <div class="decorative-circle circle-2"></div>
    <div class="decorative-circle circle-3"></div>
  </div>

  <!-- Lado Direito - Formulario -->
  <div class="signup-form-section">
    <div class="form-container">
      <!-- Header do Formulario -->
      <div class="form-header">
        <h2>{{ 'signup.form.titulo' | translate }}</h2>
        <p>{{ 'signup.form.subtitulo' | translate }}</p>
        <div *ngIf="modoSocial !== 'padrao'" class="social-badge" role="status"
             [attr.aria-label]="modoSocial === 'google'
               ? ('social_login.cadastrando_com_google' | translate)
               : ('social_login.cadastrando_com_apple' | translate)">
          <img *ngIf="modoSocial === 'google'" src="assets/images/google-icon.svg" alt="Google" class="social-badge-icon" />
          <img *ngIf="modoSocial === 'apple'" src="assets/images/apple-icon.svg" alt="Apple" class="social-badge-icon social-badge-icon-apple" />
          <span>{{ modoSocial === 'google'
            ? ('social_login.cadastrando_com_google' | translate)
            : ('social_login.cadastrando_com_apple' | translate) }}</span>
        </div>
      </div>

      <!-- Formulario -->
      <div class="form-content">
        <!-- Nome -->
        <div class="input-group">
          <label for="nome">{{ 'signup.labels.nome' | translate }} <span class="required">*</span></label>
          <div class="input-wrapper">
            <i class="pi pi-user input-icon"></i>
            <input
              pInputText
              id="nome"
              [(ngModel)]="nome"
              [placeholder]="'signup.placeholders.digite_seu_nome' | translate"
              autocomplete="off"
              maxlength="100"
            />
          </div>
          <!-- Problema 10 - Feedback por campo: Nome -->
          <small *ngIf="tentouSubmeter && !nome" class="campo-erro">
            {{ 'signup.erros.nome_obrigatorio' | translate }}
          </small>
          <!-- BUG-06 - Feedback inline para nome muito curto -->
          <small *ngIf="tentouSubmeter && nome && nome.trim().length < 4" class="campo-erro">
            {{ 'signup.erros.nome_muito_curto' | translate }}
          </small>
        </div>

        <!-- Telefone com DDI (componente compartilhado) -->
        <div class="input-group">
          <app-phone-input
            [(telefone)]="telefone"
            [(ddi)]="paisSelecionado"
            [label]="'signup.labels.numero_de_telefone' | translate"
            [required]="true"
            inputStyleClass="telefone-input">
          </app-phone-input>
          <!-- Validacao: telefone obrigatorio -->
          <small *ngIf="tentouSubmeter && !telefone" class="campo-erro">
            {{ 'signup.erros.telefone_obrigatorio' | translate }}
          </small>
          <!-- Validacao: digitos insuficientes -->
          <small *ngIf="tentouSubmeter && telefone && telefone.length < 7" class="campo-erro">
            {{ 'signup.erros.telefone_digitos_insuficientes' | translate }}
          </small>
        </div>

        <!-- RUC em linha completa -->
        <div class="input-group">
          <label for="ruc">{{ 'signup.labels.ruc' | translate }} <span class="required">*</span></label>
          <div class="input-wrapper">
            <i class="pi pi-id-card input-icon"></i>
            <input
              pInputText
              id="ruc"
              [(ngModel)]="ruc"
              [placeholder]="'signup.placeholders.informe_seu_ruc' | translate"
              autocomplete="off"
              maxlength="20"
              inputmode="tel"
              (input)="filtrarRuc($event)"
            />
          </div>
          <!-- Problema 10 - Feedback por campo: RUC -->
          <small *ngIf="tentouSubmeter && !ruc" class="campo-erro">
            {{ 'signup.erros.ruc_obrigatorio' | translate }}
          </small>
          <small *ngIf="avisoRuc" class="campo-erro">{{ avisoRuc }}</small>
        </div>

        <!-- Atividade em linha completa -->
        <div class="input-group">
          <label for="atividade">{{ 'signup.labels.atividade_da_empresa' | translate }} <span class="required">*</span></label>
          <div class="input-wrapper dropdown-wrapper">
            <i class="pi pi-briefcase input-icon"></i>
            <p-dropdown
              id="atividade"
              [options]="atividades"
              optionLabel="label"
              optionValue="value"
              [placeholder]="'signup.placeholders.selecione_a_atividade' | translate"
              [(ngModel)]="atividadeDaEmpresa"
              [showClear]="true"
              [filter]="true"
              styleClass="w-full custom-dropdown"
              appendTo="body"
            ></p-dropdown>
          </div>
          <!-- Problema 10 - Feedback por campo: Atividade -->
          <small *ngIf="tentouSubmeter && !atividadeDaEmpresa" class="campo-erro">
            {{ 'signup.erros.atividade_obrigatoria' | translate }}
          </small>
        </div>

        <!-- Cidade em linha completa -->
        <div class="input-group">
          <label for="cidade">{{ 'signup.labels.cidade' | translate }} <span class="required">*</span></label>
          <div class="input-wrapper dropdown-wrapper">
            <i class="pi pi-map-marker input-icon"></i>
            <p-dropdown
              id="cidade"
              [options]="cidades"
              optionLabel="label"
              optionValue="value"
              [placeholder]="'signup.placeholders.selecione_a_cidade' | translate"
              [(ngModel)]="cidadeId"
              [showClear]="true"
              [filter]="true"
              [disabled]="carregandoCidades"
              styleClass="w-full custom-dropdown"
              appendTo="body"
            >
              <ng-template let-cidade pTemplate="item">
                <div class="cidade-item">
                  <span class="cidade-item-nome">{{ cidade.label }}</span>
                  <span *ngIf="cidade.nomeEstado" class="cidade-item-estado"> - {{ cidade.nomeEstado }}</span>
                </div>
              </ng-template>
              <ng-template let-cidade pTemplate="selectedItem">
                <span *ngIf="cidade">{{ cidade.label }}<span *ngIf="cidade.nomeEstado"> - {{ cidade.nomeEstado }}</span></span>
              </ng-template>
            </p-dropdown>
          </div>
          <!-- Carregando cidades -->
          <small *ngIf="carregandoCidades" class="loading-text">
            <i class="pi pi-spin pi-spinner"></i>
            {{ 'signup.small.carregando_cidades' | translate }}
          </small>
          <!-- Problema 9 - Erro ao carregar cidades com botão de retry -->
          <small *ngIf="erroCidades && !carregandoCidades" class="campo-erro">
            <i class="pi pi-exclamation-triangle"></i>
            {{ 'signup.mensagens.erro_carregar_cidades' | translate }}
            <a class="link-retry" (click)="carregarCidades()">{{ 'signup.links.tentar_novamente' | translate }}</a>
          </small>
          <!-- Problema 10 - Feedback por campo: Cidade -->
          <small *ngIf="tentouSubmeter && cidadeId === null && !carregandoCidades" class="campo-erro">
            {{ 'signup.erros.cidade_obrigatoria' | translate }}
          </small>
        </div>

        <!-- Moeda em linha completa -->
        <div class="input-group">
          <label for="moeda">
            {{ 'signup.labels.moeda' | translate }} <span class="required">*</span>
            <i class="pi pi-info-circle moeda-info-icon"
               [pTooltip]="'signup.labels.moeda_tooltip' | translate"
               tooltipPosition="top"></i>
          </label>
          <div class="input-wrapper dropdown-wrapper">
            <i class="pi pi-money-bill input-icon"></i>
            <p-dropdown
              id="moeda"
              [options]="moedaOptions"
              optionLabel="label"
              optionValue="value"
              [placeholder]="'signup.placeholders.selecione_a_moeda' | translate"
              [(ngModel)]="moeda"
              styleClass="w-full custom-dropdown"
              appendTo="body"
            ></p-dropdown>
          </div>
          <!-- Feedback por campo: Moeda -->
          <small *ngIf="tentouSubmeter && !moeda" class="campo-erro">
            {{ 'signup.erros.moeda_obrigatoria' | translate }}
          </small>
        </div>

        <!-- Email em linha completa -->
        <div class="input-group">
          <label for="emailUsuario">{{ 'signup.labels.email_do_usuario' | translate }} <span class="required">*</span></label>
          <div class="input-wrapper">
            <i class="pi pi-envelope input-icon"></i>
            <input
              pInputText
              id="emailUsuario"
              [(ngModel)]="emailUsuario"
              [placeholder]="'signup.placeholders.digite_seu_email' | translate"
              autocomplete="off"
              type="email"
              [readonly]="modoSocial !== 'padrao'"
              [class.input-readonly]="modoSocial !== 'padrao'"
            />
          </div>
          <!-- Problema 10 - Feedback por campo: E-mail -->
          <small *ngIf="tentouSubmeter && !emailUsuario" class="campo-erro">
            {{ 'signup.erros.email_obrigatorio' | translate }}
          </small>
          <!-- BUG-07: Feedback inline para email preenchido mas com formato inválido -->
          <small *ngIf="tentouSubmeter && emailFormatoInvalido" class="campo-erro">
            {{ 'signup.erros.email_formato_invalido' | translate }}
          </small>
        </div>

        <!-- Grid 2 colunas para Senhas (oculto em modo social) -->
        <div class="input-row" *ngIf="modoSocial === 'padrao'">
          <!-- Senha -->
          <div class="input-group">
            <label for="senha">{{ 'signup.labels.senha' | translate }} <span class="required">*</span></label>
            <div class="input-wrapper password-wrapper">
              <i class="pi pi-lock input-icon"></i>
              <p-password
                [(ngModel)]="senha"
                [feedback]="false"
                [toggleMask]="true"
                id="senha"
                [placeholder]="'signup.placeholders.digite_sua_senha' | translate"
                autocomplete="off"
                styleClass="custom-password"
                [maxlength]="100"
              ></p-password>
            </div>
            <!-- Problema 10 - Feedback por campo: Senha -->
            <small *ngIf="tentouSubmeter && !senha" class="campo-erro">
              {{ 'signup.erros.senha_obrigatoria' | translate }}
            </small>
            <!-- BUG-15: Feedback inline para senha muito curta -->
            <small *ngIf="tentouSubmeter && senha && senha.length < 6" class="campo-erro">
              {{ 'signup.erros.senha_muito_curta' | translate }}
            </small>
          </div>

          <!-- Confirmar Senha -->
          <div class="input-group">
            <label for="confirmarSenha">{{ 'signup.labels.confirmar_senha' | translate }} <span class="required">*</span></label>
            <div class="input-wrapper password-wrapper">
              <i class="pi pi-lock input-icon"></i>
              <p-password
                [(ngModel)]="confirmarSenha"
                [feedback]="false"
                [toggleMask]="true"
                id="confirmarSenha"
                [placeholder]="'signup.placeholders.confirme_sua_senha' | translate"
                autocomplete="off"
                styleClass="custom-password"
                [maxlength]="100"
              ></p-password>
            </div>
            <!-- Problema 10 - Feedback por campo: Confirmar Senha -->
            <small *ngIf="tentouSubmeter && !confirmarSenha" class="campo-erro">
              {{ 'signup.erros.confirmar_senha_obrigatoria' | translate }}
            </small>
            <!-- BUG-16: Feedback inline para senhas divergentes -->
            <small *ngIf="tentouSubmeter && confirmarSenha && confirmarSenha !== senha" class="campo-erro">
              {{ 'signup.erros.senhas_nao_conferem' | translate }}
            </small>
          </div>
        </div>
      </div>

      <div *ngIf="modoSocial === 'padrao'" class="social-signup-section">
        <div class="social-divider">
          <span>{{ 'social_login.ou_cadastre_com' | translate }}</span>
        </div>
        <div class="social-buttons">
          <button
            type="button"
            class="btn-social-google"
            (click)="cadastrarComGoogle()"
            [disabled]="loadingGoogleSignup || carregandoCadastro"
            [attr.aria-label]="'social_login.cadastrar_google' | translate"
          >
            <i *ngIf="loadingGoogleSignup" class="pi pi-spin pi-spinner"></i>
            <img *ngIf="!loadingGoogleSignup" src="assets/images/google-icon.svg" alt="Google" />
            <span>{{ 'social_login.cadastrar_google' | translate }}</span>
          </button>

          <button
            type="button"
            class="btn-social-apple"
            (click)="cadastrarComApple()"
            [disabled]="loadingGoogleSignup || loadingAppleSignup || carregandoCadastro"
            [attr.aria-label]="'social_login.cadastrar_apple' | translate"
          >
            <i *ngIf="loadingAppleSignup" class="pi pi-spin pi-spinner"></i>
            <img *ngIf="!loadingAppleSignup" src="assets/images/apple-icon.svg" alt="Apple" />
            <span>{{ 'social_login.cadastrar_apple' | translate }}</span>
          </button>
        </div>
      </div>

      <!-- Botoes -->
      <div class="form-actions">
        <button
          pButton
          type="button"
          [label]="'signup.buttons.voltar' | translate"
          icon="pi pi-arrow-left"
          class="btn-voltar"
          severity="secondary"
          (click)="voltar()"
        ></button>

        <!-- Problema 7 - Estado de carregamento no botão cadastrar -->
        <button
          pButton
          type="button"
          [label]="'signup.buttons.cadastrar' | translate"
          icon="pi pi-check"
          iconPos="right"
          class="btn-cadastrar"
          [loading]="carregandoCadastro"
          [disabled]="carregandoCadastro"
          (click)="cadastrar()"
        ></button>
      </div>

      <!-- Link para Login -->
      <div class="login-link">
        <span>{{ 'signup.links.ja_tem_conta' | translate }}</span>
        <a [routerLink]="['/login']">{{ 'signup.links.fazer_login' | translate }}</a>
      </div>
    </div>
  </div>

  <!-- Toast de mensagens -->
  <p-toast></p-toast>
</div>
